import CommunityAmenity from "./amenities/community";

export default class Community {
    id = null;
    slug = null;
    status = null;
    bunit_rid = null;
    parent_id = null;
    location_id = null;
    group = 'community';
    meta = {
        interactives: [],
        videos: [],
        info: {
            name: null,
            tagline: null,
            description: null,
            address: {
                street1: null,
                street2: null,
                city: null,
                state: null,
                zip: null,
            },
            hubspot_scheduling_url: null,
            geo: {
                lat: 0,
                lng: 0
            },
            website: null,
            service_fees: [],
            interest_rate: 5,
        },
        sales_office: {
            address: {
                street1: null,
                street2: null,
                city: null,
                state: null,
                zip: null,
                in_community: false,
                lot_id: null
            },
            geo: {
                lat: 0,
                lng: 0
            },
            phone: null,
            hours: [
                { start: null, end: null, appointment: false },
                { start: null, end: null, appointment: false },
                { start: null, end: null, appointment: false },
                { start: null, end: null, appointment: false },
                { start: null, end: null, appointment: false },
                { start: null, end: null, appointment: false },
                { start: null, end: null, appointment: false }
            ],
            email: 'hello@oakwoodhomesco.com',
        },
        amenities: []
    };
    image = null;
    kova = {};
    created_at = null;
    updated_at = null;
    deleted_at = null;

    constructor(data) {
        this.id = data?.id ?? this.id;
        this.slug = data?.slug ?? this.slug;
        this.status = data?.status ?? this.status;
        this.bunit_rid = data?.bunit_rid ?? this.bunit_rid;
        this.parent_id = data?.parent_id ?? this.parent_id;
        this.location_id = data?.location_id ?? this.location_id;
        this.group = data?.group ?? this.group;
        this.meta = {
            interactives: data?.meta?.interactives ?? this.meta.interactives,
            videos: data?.meta?.videos ?? this.meta.videos,
            info: {
                name: data?.meta?.info?.name ?? data?.kova?.Name ?? this.meta.info.name,
                tagline: data?.meta?.info?.tagline ?? this.meta.info.tagline,
                description: data?.meta?.info?.description ?? this.meta.info.description,
                address: {
                    street1: data?.meta?.info?.address?.street1 ?? this.meta.info.address.street1,
                    street2: data?.meta?.info?.address?.street2 ?? this.meta.info.address.street2,
                    city: data?.meta?.info?.address?.city ?? this.meta.info.address.city,
                    state: data?.meta?.info?.address?.state ?? this.meta.info.address.state,
                    zip: data?.meta?.info?.address?.zip ?? this.meta.info.address.zip,
                },
                hubspot_scheduling_url: data?.meta?.info?.hubspot_scheduling_url ?? this.meta.info.hubspot_scheduling_url,
                geo: {
                    lat: data?.meta?.info?.geo?.lat ?? this.meta.info.geo.lat,
                    lng: data?.meta?.info?.geo?.lng ?? this.meta.info.geo.lng
                },
                website: data?.meta?.info?.website ?? this.meta.info.website,
                service_fees: data?.meta?.info?.service_fees ?? this.meta.info.service_fees,
                interest_rate: data?.meta?.info?.interest_rate ?? this.meta.info.interest_rate,
            },
            sales_office: {
                address: {
                    street1: data?.meta?.sales_office?.address?.street1 ?? this.meta.sales_office.address.street1,
                    street2: data?.meta?.sales_office?.address?.street2 ?? this.meta.sales_office.address.street2,
                    city: data?.meta?.sales_office?.address?.city ?? this.meta.sales_office.address.city,
                    state: data?.meta?.sales_office?.address?.state ?? this.meta.sales_office.address.state,
                    zip: data?.meta?.sales_office?.address?.zip ?? this.meta.sales_office.address.zip,
                    in_community: data?.meta?.sales_office?.address?.in_community ?? this.meta.sales_office.address.in_community,
                    lot_id: data?.meta?.sales_office?.address?.lot_id ?? this.meta.sales_office.address.lot_id
                },
                geo: {
                    lat: data?.meta?.sales_office?.geo?.lat ?? this.meta.sales_office.geo.lat,
                    lng: data?.meta?.sales_office?.geo?.lng ?? this.meta.sales_office.geo.lng

                },
                phone: data?.meta?.sales_office?.phone ?? this.meta.sales_office.phone,
                hours: [
                    { 
                        start: data?.meta?.sales_office?.hours[0]?.start ?? this.meta.sales_office.hours[0].start, 
                        end: data?.meta?.sales_office?.hours[0]?.end ?? this.meta.sales_office.hours[0].end, 
                        appointment: data?.meta?.sales_office?.hours[0]?.appointment ?? this.meta.sales_office.hours[0].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[1]?.start ?? this.meta.sales_office.hours[1].start, 
                        end: data?.meta?.sales_office?.hours[1]?.end ?? this.meta.sales_office.hours[1].end, 
                        appointment: data?.meta?.sales_office?.hours[1]?.appointment ?? this.meta.sales_office.hours[1].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[2]?.start ?? this.meta.sales_office.hours[2].start, 
                        end: data?.meta?.sales_office?.hours[2]?.end ?? this.meta.sales_office.hours[2].end, 
                        appointment: data?.meta?.sales_office?.hours[2]?.appointment ?? this.meta.sales_office.hours[2].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[3]?.start ?? this.meta.sales_office.hours[3].start, 
                        end: data?.meta?.sales_office?.hours[3]?.end ?? this.meta.sales_office.hours[3].end, 
                        appointment: data?.meta?.sales_office?.hours[3]?.appointment ?? this.meta.sales_office.hours[3].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[4]?.start ?? this.meta.sales_office.hours[4].start, 
                        end: data?.meta?.sales_office?.hours[4]?.end ?? this.meta.sales_office.hours[4].end, 
                        appointment: data?.meta?.sales_office?.hours[4]?.appointment ?? this.meta.sales_office.hours[4].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[5]?.start ?? this.meta.sales_office.hours[5].start, 
                        end: data?.meta?.sales_office?.hours[5]?.end ?? this.meta.sales_office.hours[5].end, 
                        appointment: data?.meta?.sales_office?.hours[5]?.appointment ?? this.meta.sales_office.hours[5].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[6]?.start ?? this.meta.sales_office.hours[6].start, 
                        end: data?.meta?.sales_office?.hours[6]?.end ?? this.meta.sales_office.hours[6].end, 
                        appointment: data?.meta?.sales_office?.hours[6]?.appointment ?? this.meta.sales_office.hours[6].appointment 
                    },
                ],
                email: data?.meta?.sales_office?.email ?? this.meta.sales_office.email,
            },
            amenities: (data?.meta?.amenities ?? []).map(amenity => new CommunityAmenity(amenity)) ?? this.meta.amenities
        };
        this.image = data?.image ?? this.image;
        this.kova = data?.kova ?? this.kova;
        this.created_at = data?.created_at ?? this.created_at;
        this.updated_at = data?.updated_at ?? this.updated_at;
        this.deleted_at = data?.deleted_at ?? this.deleted_at;

        return this;
    }

    get name() {
        return this?.meta?.info?.name ?? this?.kova?.Name ?? null
    }
}